module.exports = __webpack_public_path__ + "static/media/13-IMG_6722.a2a58da6.JPG";